import { render, staticRenderFns } from "./account-manage.vue?vue&type=template&id=38a30ecc&scoped=true"
import script from "./account-manage.vue?vue&type=script&lang=js"
export * from "./account-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a30ecc",
  null
  
)

export default component.exports